import styled from "vue-styled-components";

export const NoticeType = styled("div", { color: String, isSchool: Boolean, isArticle: Boolean })`
    cursor: ${props => (props.isSchool ? "auto" : "pointer")}
    color: #${props => props.color};
    font-size: 1.4rem;
    display: inline-flex;
    align-items: center;
    padding: 1.8rem 1.8rem 0;
`;

export const NoticeTitle = styled("div")`
    .notice-title {
        font-size: 1.6rem;
        font-weight: bold;
        margin-bottom: 1.4rem;
    }

    img {
        width: 100%;
    }
`;

export const NoticeEmpty = styled("div")`
    font-size: 1.8rem;
    text-align: center;
    color: #b9b9b9;

    svg {
        margin-bottom: 1.6rem;
        font-size: 3.2rem;
    }
`;

export const NoticeFooter = styled("div")`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1.2rem;
    padding-bottom: 0.6rem;
    user-select: none;

    .footer-button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16rem;
        cursor: pointer;

        svg {
            font-size: 1.8rem;
        }
    }
`;

export const MainImageHistory = styled("div")`
    img {
        width: 100%;
    }
`;

export const ImageHistory = styled("div")`
    display: flex;
    align-items: center;
    width: 100%;

    img {
        width: 20%;
        padding: 10px;
        cursor: pointer;
    }
`;
